@if (header()) {
  <h2 class="header-top">{{ header() }}</h2>
}

<div
  [class]="dragAndDropClass()"
  [class.processing]="processing"
  (dragover)="onDragOver($event)"
  (drop)="onDropSuccess($event)"
>
  @if (text()) {
    <label class="custom-file-upload">
      <p class="text-link mb-0">{{ text() }}</p>
      <input (change)="onChange($event)" type="file" />
    </label>
  }
</div>

@if (processingText()) {
  <div [class]="dragAndDropProgressClass()" [class.processing]="processing">{{ processingText() }}></div>
}
